<!--<template>
  <div class="page">
    <template v-if="!isMobile()">
      <div class="card_wrapper">
        <div v-if="allData && !viewingPatientChart" class="welcome">
          <h1 class="welcome__title">
            {{ sessionDisplayName }}
          </h1>
          <h2 class="welcome__subtitle" v-if="triedToResetPassword">
            Please log out before attempting to reset a password
          </h2>
          <h2 class="welcome__subtitle" v-if="cdaList.length === 0">
            Upload a <router-link to="/cdas">document</router-link> to get started
          </h2>
          <h2 class="welcome__subtitle" v-if="viewingPatientChart && !invited">
            <a href="#" @click.prevent="invite">(Invite)</a>
          </h2>
          <h2 class="welcome__subtitle" v-if="viewingPatientChart && invited">
            <a href="#" @click.prevent="uninvite">(Revoke Invitation)</a>
          </h2>
        </div>
        <div v-else class="welcome__card">
          <h2 class="header capitalize homecard">
            <span v-if="allData.patient.firstName">{{
              allData.patient.firstName.toLowerCase() + " "
            }}</span>
            <span v-if="allData.patient.middleName">{{
              allData.patient.middleName.toLowerCase() + " "
            }}</span>
            <span v-if="allData.patient.lastName">{{
              allData.patient.lastName.toLowerCase()
            }}</span>
          </h2>
          <welcome-bio :patient="allData.patient" />
        </div>
        <div v-if="viewingPatientChart && favorite" class="welcome__card">
          <h2 class="header capitalize homecard">
            <span>
              {{
                favorite.id.length > 20
                  ? allData.relationDescriptions.find(
                      (rel) => rel.id == favorite.relationType
                    ).value
                  : favorite.id
              }}
            </span>
          </h2>
          <div class="table-container">
            <table class="emergency_table" aria-label="welcome biography">
              <tbody>
                <tr v-if="favorite.firstName || favorite.lastName">
                  <td class="welcome__info">
                    <font-awesome-icon :icon="['fas', 'pencil-alt']" class="icon" /><b>
                      Name:
                    </b>
                    {{ favorite.firstName ? favorite.firstName + " " : ""
                    }}{{ favorite.lastName ? favorite.lastName : "" }}
                  </td>
                </tr>
                <tr v-if="favorite.primaryPhone">
                  <td class="welcome__info">
                    <font-awesome-icon :icon="['fas', 'phone']" class="icon" /><b>{{
                      favorite.primaryPhoneType
                        ? allData.phoneTypes.find(
                            (type) => type.id == favorite.primaryPhoneType
                          ).type + ": "
                        : "Primary: "
                    }}</b
                    ><a class="phone1" :href="'tel:' + favorite.primaryPhone">{{
                      favorite.primaryPhone
                    }}</a>
                  </td>
                </tr>
                <tr v-if="favorite.secondaryPhone">
                  <td class="welcome__info">
                    <font-awesome-icon :icon="['fas', 'phone']" class="icon" /><b>{{
                      favorite.secondaryPhoneType
                        ? allData.phoneTypes.find(
                            (type) => type.id == favorite.secondaryPhoneType
                          ).type + ": "
                        : "Secondary: "
                    }}</b
                    ><a class="phone1" :href="'tel:' + favorite.secondaryPhone">{{
                      favorite.secondaryPhone
                    }}</a>
                  </td>
                </tr>
                <tr v-if="favorite.email">
                  <td class="welcome__info">
                    <font-awesome-icon :icon="['fas', 'inbox']" class="icon" /><b>
                      E-mail: </b
                    ><a class="email" :href="'mailto:' + favorite.email">{{
                      favorite.email
                    }}</a>
                  </td>
                </tr>
                <tr v-if="getFullAddress() != ''">
                  <td class="welcome__info">
                    <font-awesome-icon
                      :icon="['fas', 'map-marker-alt']"
                      class="icon"
                    /><b> Address: </b>{{ getFullAddress() }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <welcome-quick-nav :key="allData.patient.externId"></welcome-quick-nav>
    </template>
    <template v-else>
      <div v-if="allData && !viewingPatientChart" class="welcome">
        <!~~ <h1 class="welcome__title">
          {{ allData.patient.firstName + " " + allData.patient.lastName }}
        </h1> ~~>
        <h2 class="welcome__subtitle" v-if="triedToResetPassword">
          Please log out before attempting to reset a password
        </h2>
        <h2 class="welcome__subtitle" v-if="cdaList.length === 0">
          Upload a <router-link to="/cdas">document</router-link> to get started
        </h2>
        <h2 class="welcome__subtitle" v-if="viewingPatientChart && !invited">
          <a href="#" @click.prevent="invite">(Invite)</a>
        </h2>
        <h2 class="welcome__subtitle" v-if="viewingPatientChart && invited">
          <a href="#" @click.prevent="uninvite">(Revoke Invitation)</a>
        </h2>
        <welcome-quick-nav :key="allData.patient.externId"></welcome-quick-nav>
      </div>
      <section v-else class="mobile-form-section">
        <div class="mobile-form-btn-wrapper">
          <button @click="showPatientDemoMobile" class="mobile-form-btn blue-btn">
            Patient Demographics
            <font-awesome-icon v-if="patientDemoClosed" :icon="['fas', 'caret-right']" />
            <font-awesome-icon v-else :icon="['fas', 'caret-down']" />
          </button>
          <div class="mobile-dropdown-content">
            <welcome-bio :patient="allData.patient" />
          </div>
        </div>
        <div v-if="favorite" class="mobile-form-btn-wrapper">
          <button @click="showFavoriteDemoMobile" class="mobile-form-btn blue-btn">
            {{
              favorite.id.length > 20
                ? allData.relationDescriptions.find(
                    (rel) => rel.id == favorite.relationType
                  ).value
                : favorite.id
            }}
            <font-awesome-icon v-if="favDemoClosed" :icon="['fas', 'caret-right']" />
            <font-awesome-icon v-else :icon="['fas', 'caret-down']" />
          </button>
          <div class="mobile-dropdown-content">
            <p>Name: {{ `${favorite.firstName} ${favorite.lastName}` }}</p>
            <p v-if="favorite.primaryPhone">
              Primary Number:
              <a :href="'tel:' + favorite.primaryPhone">{{ favorite.primaryPhone }}</a>
            </p>
            <p v-if="favorite.secondaryPhone">
              Secondary Number:
              <a :href="'tel:' + favorite.secondaryPhone">{{
                favorite.secondaryPhone
              }}</a>
            </p>
            <p v-if="favorite.email">
              E-mail: <a :href="'mailto:' + favorite.email">{{ favorite.email }}</a>
            </p>
          </div>
        </div>
        <div class="mobile-form-btn-wrapper">
          <router-link to="/search?category=contact&query=" class="mobile-form-btn"
            >View My Team</router-link
          >
        </div>
        <div class="mobile-form-btn-wrapper">
          <router-link to="/currentDiagnosis" class="mobile-form-btn"
            >View Diagnosis</router-link
          >
        </div>
        <div class="mobile-form-btn-wrapper">
          <router-link to="/currentMedications" class="mobile-form-btn"
            >View Medication</router-link
          >
        </div>
        <div class="mobile-form-btn-wrapper">
          <router-link to="/vitalsGroup/all" class="mobile-form-btn"
            >View Vitals</router-link
          >
        </div>
        <div class="mobile-form-btn-wrapper">
          <router-link to="/allergy" class="mobile-form-btn">View Allergies</router-link>
        </div>
        <div class="mobile-form-btn-wrapper">
          <router-link to="/currentProviders" class="mobile-form-btn"
            >View Providers</router-link
          >
        </div>
        <div class="mobile-form-btn-wrapper">
          <router-link to="/currentProcedures" class="mobile-form-btn"
            >View Procedures</router-link
          >
        </div>
        <div class="mobile-form-btn-wrapper">
          <router-link to="/patientNurse" class="mobile-form-btn"
            >View Nurses</router-link
          >
        </div>
        <div class="mobile-form-btn-wrapper">
          <router-link to="/notes" class="mobile-form-btn">View Notes</router-link>
        </div>
        <div class="mobile-form-btn-wrapper">
          <router-link to="/orders" class="mobile-form-btn">View Orders</router-link>
        </div>
      </section>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import WelcomeQuickNav from "./WelcomeQuickNav";
import WelcomeBio from "./WelcomeBio";
import { isViewingPatientChart, getInvited } from "@/data/getters";
import { exitPatientChart, invitePatient, uninvitePatient } from "@/api/sessionApi";
import { getPrimaryContact } from "@/data/getters";
import { getContacts } from "@/api/userApi";
import { useSessionSelfStore } from "@/stores/sessionSelf";
import { sessionActorFrom } from "@/utils/sessionIdentity";
import $ from "jquery";

export default {
  name: "welcome-page",
  data() {
    return {
      favorite: null,
      favDemoClosed: true,
      patientDemoClosed: true,
    };
  },
  components: {
    "welcome-quick-nav": WelcomeQuickNav,
    "welcome-bio": WelcomeBio,
  },
  created() {
    let loader = this.$loading.show(
      {},
      {
        after: this.$createElement("div", {}, ["Loading account data..."]),
      }
    );
    getContacts()
      .then((a) => {
        this.favorite = getPrimaryContact(a);
        loader.hide();
        loader = null;
      })
      .catch((err) => {
        console.log(err);
        alert(err);
        loader.hide();
        loader = null;
      });
  },
  // setTimeout(() => {
  //   loader.hide()
  //   loader = null
  // }, 3500)
  computed: {
    triedToResetPassword() {
      return (
        "triedToResetPassword" in window.sessionStorage &&
        window.sessionStorage.triedToResetPassword - Date.now() < 40 * 1000
      );
    },
    ...mapGetters("login", {
      allData: "getAllData",
      // user: 'getUser',
      isLoggedIn: "isLoggedIn",
    }),
    ...mapGetters("login/cda", {
      cdaList: "getCdaList",
    }),
    viewingPatientChart: function () {
      console.log(this.allData);
      return isViewingPatientChart(this.allData);
    },
    invited: function () {
      return getInvited(this.allData);
    },
    /** Logged-in account display name (MySQL self when loaded). */
    sessionDisplayName() {
      return (
        sessionActorFrom(this.allData, useSessionSelfStore().profile)
          .displayName || ""
      );
    },
  },
  methods: {
    revert: function () {
      exitPatientChart().then(() =>
        setTimeout(() => {
          window.location.reload();
        }, 6800)
      );
    },
    invite: function () {
      invitePatient().then(() =>
        setTimeout(() => {
          window.location.reload();
        }, 800)
      );
    },
    uninvite: function () {
      uninvitePatient().then(() =>
        setTimeout(() => {
          window.location.reload();
        }, 800)
      );
    },
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    },
    showPatientDemoMobile(e) {
      let dropdown = $(e.srcElement).next(".mobile-dropdown-content");
      dropdown.slideToggle();
      this.patientDemoClosed = !this.patientDemoClosed;
    },
    showFavoriteDemoMobile(e) {
      let dropdown = $(e.srcElement).next(".mobile-dropdown-content");
      dropdown.slideToggle();
      this.favDemoClosed = !this.favDemoClosed;
    },
    getFullAddress() {
      let answer = "";
      let values = [this.favorite.address1, this.favorite.address2, this.favorite.city];
      values.forEach(function (item) {
        if (item) {
          if (answer === "") answer += item;
          else answer = answer + ", " + item;
        }
      });
      if (this.favorite.state) {
        let stateName = this.allData.states.find(
          (state) => state.id == this.favorite.state
        ).name;
        if (answer == "") answer += stateName;
        else answer = answer + ", " + stateName;
      }
      if (this.favorite.zip) {
        if (answer == "") answer += this.favorite.zip;
        else answer = answer + ", " + this.favorite.zip;
      }
      return answer;
    },
  },
};
</script>

<style scoped lang="scss">
$color-font: #58595b;

.page {
  margin: 0 auto;
  width: 100%;
}
.welcome {
  text-align: center;
  flex: 1;
}
.welcome__title {
  font-size: 1.8em;
  color: $color-font;
}
.welcome__subtitle {
  font-size: 1.3em;
  color: $color-font;
}

.card_wrapper {
  text-align: center;
  // width: 700px;
  margin: auto;
  display: flex;
}

.welcome__info {
  color: $color-font;
  line-height: 1.8em;
}

.icon {
  margin-right: 0.5em;
}
.welcome__card {
  border: 1px solid lightgray;
  border-radius: 5px;
  margin: 0 auto;
  width: 700px;
  text-align: left;
  display: inline-block;
  flex: 1;
}

.header {
  text-align: center;
  color: #fff;
  font-size: 1.2em;
  padding: 5px 0;
  background-color: #007bff;
}

.homecard {
  margin-top: unset;
}

.capitalize {
  text-transform: capitalize;
}

.table-container {
  padding: 1em 2em 1.5em;
}

@media only screen and (max-width: 768px) {
  .page {
    padding-bottom: 0;
  }
  .welcome__title {
    font-size: 1.5em;
  }
}

.mobile-form-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 5%;
}

.mobile-form-btn-wrapper {
  width: 100%;
  max-width: 350px;
  background-color: white; /* White frame background */
  border: 1px solid #ccc;
  border-radius: 5px;
  margin-bottom: 10px;
  padding: 5px; /* Padding to create the white frame */
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1);
}

.mobile-form-btn {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 15px;
  font-size: 16px;
  cursor: pointer;
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border-radius: 5px;
  text-decoration: none;
}

.mobile-form-btn.blue-btn {
  background-color: #0056b3; /* New color for the first two buttons */
}

.mobile-form-btn i {
  font-size: 18px;
}

.mobile-form-btn:hover {
  background-color: #0056b3;
}

.mobile-dropdown-content {
  display: none;
  background-color: #f9f9f9;
  padding: 15px;
  border-top: 1px solid white;
}

.mobile-dropdown-content p {
  margin: 5px 0;
}

.mobile-dropdown-content a {
  color: #007bff;
  text-decoration: none;
}

.mobile-dropdown-content a:hover {
  text-decoration: underline;
}
</style>-->
<template>
  <!-- eh-ds: stylebook primitives (brand-ds.scss). welcome-ds: page exceptions. -->
  <div class="page welcome-ds eh-ds">
    <div
      v-if="!(isMobile() && viewingPatientChart)"
      class="page-help-corner"
    >
      <help-icon help-id="welcome" title="Help for Welcome / Home" />
    </div>
    <template v-if="!isMobile()">
      <div class="card_wrapper">
        <div v-if="allData && !viewingPatientChart" class="welcome">
          <h1 class="welcome__title">
            {{ subjectName || sessionDisplayName }}
          </h1>
          <h2 class="welcome__subtitle" v-if="triedToResetPassword">
            Please log out before attempting to reset a password
          </h2>
          <!-- <h2 class="welcome__subtitle" v-if="cdaList.length === 0">
            Upload a <router-link to="/cdas">document</router-link> to get started
          </h2> -->
          <h2 class="welcome__subtitle" v-if="viewingPatientChart && !invited">
            <a href="#" @click.prevent="invite">(Invite)</a>
          </h2>
          <h2 class="welcome__subtitle" v-if="viewingPatientChart && invited">
            <a href="#" @click.prevent="uninvite">(Revoke Invitation)</a>
          </h2>
        </div>
        <div v-else class="welcome__card">
          <h2 class="header capitalize homecard">
            <span>{{ subjectName.toLowerCase() }}</span>
          </h2>
          <welcome-bio :patient="allData.patient" />
        </div>
        <div v-if="viewingPatientChart && favorite" class="welcome__card">
          <h2 class="header capitalize homecard">
            <span>
              {{
                favorite.relationName ||
                (allData?.relationDescriptions?.find(
                  (rel) => rel.id == favorite.relationType
                )?.value) ||
                favorite.id
              }}
            </span>
          </h2>
          <div class="table-container">
            <table class="emergency_table" aria-label="welcome biography">
              <tbody>
                <tr v-if="favorite.firstName || favorite.lastName">
                  <td class="welcome__info">
                    <font-awesome-icon :icon="['fas', 'pencil-alt']" class="icon" />
                    <b> Name: </b>
                    {{ favorite.firstName ? favorite.firstName + " " : "" }}
                    {{ favorite.lastName ? favorite.lastName : "" }}
                  </td>
                </tr>
                <tr v-if="favorite.primaryPhone">
                  <td class="welcome__info">
                    <font-awesome-icon :icon="['fas', 'phone']" class="icon" />
                    <b>
                      {{
                        favorite.primaryPhoneType && allData?.phoneTypes
                          ? (allData.phoneTypes.find(
                              (type) => type.id == favorite.primaryPhoneType
                            )?.type || "Primary") + ": "
                          : "Primary: "
                      }}
                    </b>
                    <a class="phone1" :href="'tel:' + favorite.primaryPhone">
                      {{ favorite.primaryPhone }}
                    </a>
                  </td>
                </tr>
                <tr v-if="favorite.secondaryPhone">
                  <td class="welcome__info">
                    <font-awesome-icon :icon="['fas', 'phone']" class="icon" />
                    <b>
                      {{
                        favorite.secondaryPhoneType && allData?.phoneTypes
                          ? (allData.phoneTypes.find(
                              (type) => type.id == favorite.secondaryPhoneType
                            )?.type || "Secondary") + ": "
                          : "Secondary: "
                      }}
                    </b>
                    <a class="phone1" :href="'tel:' + favorite.secondaryPhone">
                      {{ favorite.secondaryPhone }}
                    </a>
                  </td>
                </tr>
                <tr v-if="favorite.email">
                  <td class="welcome__info">
                    <font-awesome-icon :icon="['fas', 'inbox']" class="icon" />
                    <b> E-mail: </b>
                    <a class="email" :href="'mailto:' + favorite.email">
                      {{ favorite.email }}
                    </a>
                  </td>
                </tr>
                <tr v-if="getFullAddress() !== ''">
                  <td class="welcome__info">
                    <font-awesome-icon :icon="['fas', 'map-marker-alt']" class="icon" />
                    <b> Address: </b>
                    {{ getFullAddress() }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <welcome-quick-nav :key="allData.patient.externId"></welcome-quick-nav>
    </template>
    <template v-else>
      <div v-if="allData && !viewingPatientChart" class="welcome">
        <h2 class="welcome__subtitle" v-if="triedToResetPassword">
          Please log out before attempting to reset a password
        </h2>
        <!-- <h2 class="welcome__subtitle" v-if="cdaList.length === 0">
          Upload a <router-link to="/cdas">document</router-link> to get started
        </h2> -->
        <h2 class="welcome__subtitle" v-if="viewingPatientChart && !invited">
          <a href="#" @click.prevent="invite">(Invite)</a>
        </h2>
        <h2 class="welcome__subtitle" v-if="viewingPatientChart && invited">
          <a href="#" @click.prevent="uninvite">(Revoke Invitation)</a>
        </h2>
        <welcome-quick-nav :key="allData.patient.externId"></welcome-quick-nav>
      </div>
      <section v-else class="mobile-form-section">
        <div class="mobile-form-top-row">
          <div class="mobile-form-btn-wrapper">
            <button @click="showPatientDemoMobile" class="mobile-form-btn blue-btn">
              Patient Demographics
              <font-awesome-icon v-if="patientDemoClosed" :icon="['fas', 'caret-right']" />
              <font-awesome-icon v-else :icon="['fas', 'caret-down']" />
            </button>
          <div class="mobile-dropdown-content">
            <welcome-bio :patient="allData.patient" />
          </div>
        </div>
        <help-icon help-id="welcome" title="Help for Welcome / Home" />
      </div>
      <div v-if="favorite" class="mobile-form-btn-wrapper">
        <button @click="showFavoriteDemoMobile" class="mobile-form-btn blue-btn">
          {{
            favorite.relationName ||
            (allData?.relationDescriptions?.find(
              (rel) => rel.id == favorite.relationType
            )?.value) ||
            favorite.id
          }}
          <font-awesome-icon v-if="favDemoClosed" :icon="['fas', 'caret-right']" />
          <font-awesome-icon v-else :icon="['fas', 'caret-down']" />
        </button>
        <div class="mobile-dropdown-content">
          <p>Name: {{ `${favorite.firstName || ''} ${favorite.lastName || ''}`.trim() }}</p>
            <p v-if="favorite.primaryPhone">
              Primary Number:
              <a :href="'tel:' + favorite.primaryPhone">{{ favorite.primaryPhone }}</a>
            </p>
            <p v-if="favorite.secondaryPhone">
              Secondary Number:
              <a :href="'tel:' + favorite.secondaryPhone">{{
                favorite.secondaryPhone
              }}</a>
            </p>
            <p v-if="favorite.email">
              E-mail: <a :href="'mailto:' + favorite.email">{{ favorite.email }}</a>
            </p>
          </div>
        </div>
        <div class="mobile-form-btn-wrapper">
          <router-link to="/search?category=contact&query=" class="mobile-form-btn"
            >View My Team</router-link
          >
        </div>
        <div class="mobile-form-btn-wrapper">
          <router-link to="/currentDiagnosis" class="mobile-form-btn"
            >View Diagnosis</router-link
          >
        </div>
        <div class="mobile-form-btn-wrapper">
          <router-link to="/currentMedications" class="mobile-form-btn"
            >View Medication</router-link
          >
        </div>
        <div class="mobile-form-btn-wrapper">
          <router-link to="/vitalsGroup/all" class="mobile-form-btn"
            >View Vitals</router-link
          >
        </div>
        <div class="mobile-form-btn-wrapper">
          <router-link to="/allergy" class="mobile-form-btn">View Allergies</router-link>
        </div>
        <div class="mobile-form-btn-wrapper">
          <router-link to="/currentProviders" class="mobile-form-btn"
            >View Providers</router-link
          >
        </div>
        <div class="mobile-form-btn-wrapper">
          <router-link to="/currentProcedures" class="mobile-form-btn"
            >View Procedures</router-link
          >
        </div>
        <div class="mobile-form-btn-wrapper">
          <router-link to="/patientNurse" class="mobile-form-btn"
            >View Nurses</router-link
          >
        </div>
        <div class="mobile-form-btn-wrapper">
          <router-link to="/notes" class="mobile-form-btn">View Notes</router-link>
        </div>
        <div class="mobile-form-btn-wrapper">
          <router-link to="/orders" class="mobile-form-btn">View Orders</router-link>
        </div>
        <!-- The chart's Media entry on phones; see WelcomeHealthRecords for the desktop tile. -->
        <div class="mobile-form-btn-wrapper">
          <router-link :to="mediaLink" class="mobile-form-btn">View Media</router-link>
        </div>
        <div class="mobile-form-btn-wrapper">
          <router-link to="/scheduling" class="mobile-form-btn">View Availability</router-link>
        </div>
      </section>
    </template>
  </div>
</template>

<script>
import { useSessionStore } from '@/stores/session';
import { usePatientContextStore } from '@/stores/patientContext';
import { mapGetters } from "vuex";
import WelcomeQuickNav from "./WelcomeQuickNav";
import WelcomeBio from "./WelcomeBio";
import HelpIcon from "@/components/help/HelpIcon.vue";
import { isViewingPatientChart, getInvited, getPrimaryContact } from "@/data/getters";
import { exitPatientChart, invitePatient, uninvitePatient } from "@/api/sessionApi";
import { getContacts } from "@/api/userApi";
import { isSessionTimeoutError } from "@/api/request";
import { mapState } from "pinia";
import { mediaLinkFor } from "@/components/private-layouts/media/mediaNav";
import $ from "jquery";

export default {
  name: "welcome-page",
  data() {
    return {
      favorite: null,
      favDemoClosed: true,
      patientDemoClosed: true,
      loadingPrimaryContact: false,
      pendingContactReload: false,
    };
  },
  components: {
    "welcome-quick-nav": WelcomeQuickNav,
    "welcome-bio": WelcomeBio,
    HelpIcon,
  },
  created() {
    console.log("welcome page");
  },
  watch: {
    patientScopeKey: {
      immediate: true,
      handler(newScope) {
        if (newScope && this.hasPatientScope) {
          this.loadPrimaryContact();
        } else {
          this.favorite = null;
        }
      },
    },
    viewingPatientChart(isViewing) {
      if (isViewing && this.hasPatientScope) {
        this.loadPrimaryContact();
      }
    },
  },
  computed: {
    /**
     * Whose name the page is greeting.
     *
     * Reads the session rather than the legacy `getAllData` blob. That blob was
     * the whole patient record graph fetched in one call and cached in Vuex; the
     * port decomposed it into per-resource endpoints, so it no longer populates
     * and this heading rendered "undefined undefined".
     *
     * While viewing a patient's chart, the subject is that patient, from the
     * open chart — the one case where the greeting is not the signed-in user.
     */
    subjectName() {
      if (this.viewingPatientChart) {
        const p = usePatientContextStore().patient || {};
        return [p.first_name, p.middle_name, p.last_name].filter(Boolean).join(' ');
      }

      const session = useSessionStore();
      return session.displayName || '';
    },

    triedToResetPassword() {
      return (
        "triedToResetPassword" in window.sessionStorage &&
        window.sessionStorage.triedToResetPassword - Date.now() < 40 * 1000
      );
    },
    ...mapGetters("login", {
      allData: "getAllData",
      isLoggedIn: "isLoggedIn",
    }),
    ...mapGetters("login/cda", {
      cdaList: "getCdaList",
    }),
    // mapState, so the title fills in the moment `GET /me` answers.
    ...mapState(useSessionStore, {
      sessionUserDisplayName: "displayName",
    }),
    viewingPatientChart() {
      console.log(this.allData);
      return isViewingPatientChart(this.allData);
    },
    invited() {
      return getInvited(this.allData);
    },
    mediaLink() {
      return mediaLinkFor(this.allData);
    },
    /**
     * The signed-in person's name: the session's own (`GET /me`, decision D4),
     * as the account menu shows it. Never `allData`, whose `patient` is the
     * open chart; blank until `/me` has answered.
     */
    sessionDisplayName() {
      return this.sessionUserDisplayName || "";
    },
    patientScopeKey() {
      const patient = this.allData?.patient || {};
      const accountnumber =
        patient.externId2 ||
        patient.externid2 ||
        this.allData?.user?.accountnumber ||
        "";
      const patientUniqueId =
        patient.externId ||
        patient.externid ||
        patient.psersonalID ||
        patient.id ||
        "";
      return `${accountnumber}_${patientUniqueId}`;
    },
    hasPatientScope() {
      const patient = this.allData?.patient || {};
      const accountnumber =
        patient.externId2 ||
        patient.externid2 ||
        this.allData?.user?.accountnumber ||
        "";
      const patientUniqueId =
        patient.externId ||
        patient.externid ||
        patient.psersonalID ||
        patient.id ||
        "";
      return Boolean(accountnumber && patientUniqueId);
    },
  },
  methods: {
    async loadPrimaryContact() {
      const patient = this.allData?.patient || {};
      const accountnumber =
        patient.externId2 ||
        patient.externid2 ||
        this.allData?.user?.accountnumber ||
        "";
      const patientUniqueId =
        patient.externId ||
        patient.externid ||
        patient.psersonalID ||
        patient.id ||
        "";

      if (!accountnumber || !patientUniqueId) {
        this.favorite = null;
        return;
      }

      if (this.loadingPrimaryContact) {
        this.pendingContactReload = true;
        return;
      }
      this.loadingPrimaryContact = true;

      try {
        const a = await getContacts({
          accountnumber,
          patient_unique_id: patientUniqueId,
          patientUniqueId,
        });
        this.favorite = getPrimaryContact(a) || null;
      } catch (err) {
        if (isSessionTimeoutError && isSessionTimeoutError(err)) return;
        console.error("Failed to load contacts for patient:", err);
        this.favorite = null;
      } finally {
        this.loadingPrimaryContact = false;
        if (this.pendingContactReload) {
          this.pendingContactReload = false;
          this.loadPrimaryContact();
        }
      }
    },
    revert() {
      exitPatientChart().then(() =>
        setTimeout(() => {
          window.location.reload();
        }, 6800)
      );
    },
    invite() {
      invitePatient().then(() =>
        setTimeout(() => {
          window.location.reload();
        }, 800)
      );
    },
    uninvite() {
      uninvitePatient().then(() =>
        setTimeout(() => {
          window.location.reload();
        }, 800)
      );
    },
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    },
    showPatientDemoMobile(e) {
      let dropdown = $(e.srcElement).next(".mobile-dropdown-content");
      dropdown.slideToggle();
      this.patientDemoClosed = !this.patientDemoClosed;
    },
    showFavoriteDemoMobile(e) {
      let dropdown = $(e.srcElement).next(".mobile-dropdown-content");
      dropdown.slideToggle();
      this.favDemoClosed = !this.favDemoClosed;
    },
    getFullAddress() {
      if (!this.favorite) return "";
      let answer = "";
      let values = [this.favorite.address1, this.favorite.address2, this.favorite.city];
      values.forEach(function (item) {
        if (item) {
          if (answer === "") answer += item;
          else answer = answer + ", " + item;
        }
      });
      if (this.favorite.state) {
        let stateObj = this.allData?.states?.find(
          (state) => state.id == this.favorite.state
        );
        let stateName = stateObj?.name || this.favorite.stateAbbr || "";
        if (stateName) {
          if (answer === "") answer += stateName;
          else answer = answer + ", " + stateName;
        }
      } else if (this.favorite.stateAbbr) {
        if (answer === "") answer += this.favorite.stateAbbr;
        else answer = answer + ", " + this.favorite.stateAbbr;
      }
      if (this.favorite.zip) {
        if (answer === "") answer += this.favorite.zip;
        else answer = answer + ", " + this.favorite.zip;
      }
      return answer;
    },
  },
};
</script>

<style scoped lang="scss">
$color-font: #2f6f76; // deep teal — brand-aligned text

.page {
  margin: 0 auto;
  width: 100%;
}
.page-help-corner {
  display: flex;
  justify-content: flex-end;
  padding: 0.25rem 0.5rem 0;
}
.welcome {
  text-align: center;
  flex: 1;
}
.welcome__title {
  font-size: 1.8em;
  color: $color-font;
  font-family: "Inter", system-ui, sans-serif;
  font-weight: 600;
}
.welcome__subtitle {
  font-size: 1.3em;
  color: #24555b;
  font-family: "Inter", system-ui, sans-serif;
  font-weight: 400;
}

.card_wrapper {
  text-align: center;
  margin: auto;
  display: flex;
}

.welcome__info {
  color: $color-font;
  line-height: 1.8em;
}

.icon {
  margin-right: 0.5em;
}
.welcome__card {
  border: 1px solid lightgray;
  border-radius: 5px;
  margin: 0 auto;
  width: 700px;
  text-align: left;
  display: inline-block;
  flex: 1;
}

.header {
  text-align: center;
  color: #fff;
  font-size: 1.2em;
  padding: 5px 0;
  background-color: #007bff;
}

.homecard {
  margin-top: unset;
}

.capitalize {
  text-transform: capitalize;
}

.table-container {
  padding: 1em 2em 1.5em;
}

@media only screen and (max-width: 768px) {
  .page {
    padding-bottom: 0;
  }
  .welcome__title {
    font-size: 1.5em;
  }
}

.mobile-form-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 5%;
}

.mobile-form-top-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.4rem;
  width: 100%;
  max-width: 350px;
  margin-bottom: 16px;
}

.mobile-form-top-row .mobile-form-btn-wrapper {
  flex: 1 1 auto;
  width: auto;
  max-width: none;
  margin-bottom: 0;
}

.mobile-form-top-row :deep(.help-icon-btn) {
  flex: 0 0 auto;
  margin-left: 0;
}

.mobile-form-btn-wrapper {
  width: 100%;
  max-width: 350px;
  margin-bottom: 16px;
  padding: 5px;
}

.mobile-form-btn {
  background-color: #4b9ca5;
  color: white;
  border: none;
  padding: 15px;
  font-size: 16px;
  cursor: pointer;
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border-radius: 5px;
  text-decoration: none;
}

.mobile-form-btn.blue-btn {
  background-color: #2f6f76;
}

.mobile-form-btn i {
  font-size: 18px;
}

.mobile-form-btn:hover {
  background-color: #0056b3;
}

.mobile-dropdown-content {
  display: none;
  background-color: #f9f9f9;
  padding: 15px;
  border-top: 1px solid white;
}

.mobile-dropdown-content p {
  margin: 5px 0;
}

.mobile-dropdown-content a {
  color: #007bff;
  text-decoration: none;
}

.mobile-dropdown-content a:hover {
  text-decoration: underline;
}
</style>
